import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { LocationOrderRecord, LocationRecordSection } from '../../../Api/Locations/locationsApi';
import { formatDate } from '../../../utils/helpers';
import { RelatedRecordsCard } from '../../Compounds/RelatedRecordsTable/RelatedRecordsCard';
import { RelatedRecordsColumn } from '../../Compounds/RelatedRecordsTable/RelatedRecordsTable';
import { WORKFLOW_TAB_LABELS } from '../Orders/workflowTabs';

const workflowStatus = (order: LocationOrderRecord) =>
  WORKFLOW_TAB_LABELS[order.workflow_tab] || order.request_status || '';

const columns: RelatedRecordsColumn<LocationOrderRecord>[] = [
  { header: 'Order Name', cellClass: 'break-words', text: (order) => order.name || '' },
  { header: 'Request Type', headerClass: 'w-28', cellClass: 'truncate', text: (order) => order.request_type || '' },
  { header: 'Workflow Status', headerClass: 'w-36', cellClass: 'truncate', text: workflowStatus },
  { header: 'Submitted Date', headerClass: 'w-28', text: (order) => formatDate(order.created_at) }
];

export interface LocationOrdersTableProps {
  orders: LocationRecordSection<LocationOrderRecord>;
  count: number | null;
  cardActions?: ReactNode;
}

export function LocationOrdersTable({ orders, count, cardActions }: LocationOrdersTableProps) {
  const navigate = useNavigate();

  return (
    <RelatedRecordsCard
      title="Orders"
      count={count}
      section={orders}
      emptyText="No orders at this location"
      testId="location-orders"
      recordKey={(order) => order.id}
      columns={columns}
      openTitle="Open Order"
      onOpen={(order) => navigate(`/orders/${encodeURIComponent(order.id)}`)}
      cardActions={cardActions}
    />
  );
}
